<section>

    <!-- Footer -->
<footer class="page-footer font-small lighten-3 pt-4">
    <nav class="navbar navbar-expand-lg navbar-dark bg-white">
        <a class="navbar-brand" href="#">
            <img src="assets/Image/Logo/Recursos_Mesa de trabajo 1 copia 6.png" width="300" alt="Logo de Jobtec">
        </a>
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNavAltMarkup" aria-controls="navbarNavAltMarkup" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse justify-content-center" id="navbarNavAltMarkup">
          <div class="navbar-nav text-dark">
            <div class="footer-copyright text-center py-3">© 2020 Copyright:
                <a href="https://jobtes.edu.ni/"> Jobtec.edu.ni</a>
              </div>
          </div>
        </div>
        <a class="navbar-brand">
            <img src="assets/Image/Logo/Recursos_Mesa de trabajo 1 copia 5.png" width="200" alt="Emocion de Jobtec">
        </a>
      </nav>
  </footer>
  
</section>